<template>
  <!-- 选择商品弹窗 -->
  <div class="goods-abbreviation">
    <el-dialog
      title="商品缩写"
      :visible.sync="selectDialog"
      width="1200px"
      :before-close="handleDialogClose"
      class="select-goods"
      append-to-body
    >
      <template slot="title">
        <span>商品缩写</span>
      </template>
      <div class="evaluate-dialog-wrapper">
        <!-- 筛选部分 -->
        <div class="screen-box">
          <div class="line">
            <div class="item">
              <span class="item-name">指定品牌：</span>
              <!-- 指定品牌弹出框 -->
              <el-popover width="200" v-model="brandVisible">
                <div class="brand-checked-wrapper">
                  <div class="wrapper-header">
                    <span style="float: left;">指定品牌</span>
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                      style="float: right; margin-right: 0;"
                    >全选</el-checkbox>
                    <div style="clear: both;"></div>
                  </div>
                  <div style="margin: 15px 0;"></div>
                  <el-checkbox-group v-model="checkedBrands" @change="handleCheckedBrandsChange">
                    <el-checkbox
                      v-for="(item, index) in brandOptions"
                      :label="item"
                      :key="index"
                      style="display: block; margin-bottom: 8px;"
                    >{{item.pidName}}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div style="text-align: center; margin: 0">
                  <el-button size="mini" @click="brandVisible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="brandConfirm()">确定</el-button>
                </div>
                <el-button
                  slot="reference"
                  plain
                  size="small"
                  class="brandButton"
                >{{checkedBrands.length > 0 ? '已选择' + checkedBrands.length + '个' : '默认全部'}}</el-button>
              </el-popover>
            </div>
            <div class="item">
              <el-select
                v-model="classifyValue"
                placeholder="淘宝类目"
                class="classify-select"
                size="small"
                @change="classifyChange"
              >
                <el-option
                  v-for="item in classifyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-popover placement="bottom" width="300" v-model="visible" class="poper">
                <div class="popper-wrapper">
                  <el-tree
                    ref="taobaoTree"
                    node-key="id"
                    v-if="classifyIndex === 1"
                    :data="taobaoCats"
                    :props="props"
                    show-checkbox
                    @check-change="handleCheckChange"
                  ></el-tree>
                  <el-tree
                    ref="sellerTree"
                    node-key="id"
                    v-else-if="classifyIndex === 2"
                    :data="sellerCats"
                    :props="props"
                    show-checkbox
                    @check-change="handleCheckChange"
                  ></el-tree>
                </div>
                <div style="text-align: right; margin-top: 20px;">
                  <el-checkbox
                    v-model="checkedAll"
                    @change="handleCheckAllChangeTaoBao"
                    style="float:left;line-height:26px;"
                  >全选</el-checkbox>
                  <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="getCheckedKeys()">确定</el-button>
                </div>
                <el-button slot="reference" size="small" class="goods-button">
                  {{classifyIdArray.length >
                  0 ? '已选择' + classifyIdArray.length + '项' : '默认全部'}}
                </el-button>
              </el-popover>
            </div>
            <div class="item" style="margin-right: 0;">
              <el-button class="button" size="small" type="primary" @click="searchList()">查询</el-button>
            </div>
          </div>
          <div class="line">
            <div class="item"
                 style="margin-right: 15px;">
                 <span class="item-name">商品名称：</span>
              <el-input class="short-input"
                        style="width:300px;"
                        placeholder="请输入商品名称"
                        size="small"
                        v-model="itemTitle"></el-input>
            </div>
            <div class="item"
                 style="margin-right: 15px;">
                 <span class="item-name">商品ID：</span>
              <el-input class="short-input"
                        style="width:300px;"
                        placeholder="请输入商品ID,多个商品ID间用逗号分隔"
                        size="small"
                        @input="validNum"
                        @change="changeNum"
                        v-model="numIid"></el-input>
            </div>
          </div>
          <div class="line">
            <div class="item">
              <span class="item-name">商品状态：</span>
              <el-select v-model="goodValue" placeholder="全部商品" class="goods-select" size="small">
                <el-option
                  v-for="item in goodState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span class="item-name">价格：</span>
              <el-input class="short-input" size="small" v-model="startPrice"></el-input>
              <span class="text">至</span>
              <el-input class="short-input" size="small" v-model="endPrice"></el-input>
              <span class="text">元</span>
            </div>
          </div>
        </div>
        <!-- 表格部分 -->
        <div class="table-box">
          <el-table
            :data="leftData"
            max-height="440"
            :header-cell-style="{background:'#FAFAFA'}"
            style="border: 1px solid #E1E1E6;"
          >
            <el-table-column align="center" label="店中宝贝">
              <template slot-scope="scope">
                <div class="shops-goods">
                  <div class="goods-left">
                    <img :src="scope.row.picUrl" class="goods-img" alt>
                  </div>
                  <div class="goods-right">
                    <p class="goods-name">
                      <span class="goods-title">{{scope.row.itemTitle}}</span>
                    </p>
                    <div class="goods-detail">
                      <span
                        class="goods-id"
                        style="color:#888;font-size:13px;"
                      >商品ID:{{scope.row.numIid}}</span>
                      <span class="goods-price" style="float:right;font-size:18px;">
                        <span class="price">￥{{scope.row.price}}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="宝贝缩写" width="240px;">
              <!-- <template slot="header">宝贝缩写
                 
              </template>-->
              <template slot-scope="scope">{{scope.row.titleShort}}</template>
            </el-table-column>
            <el-table-column align="center" label="修改缩写">
              <template slot="header" slot-scope="scope">
                修改缩写
                <el-tooltip
                style="margin:-5px 0 0 5px;"
                  class="item"
                  effect="light"
                  content="商品名称字数比较多，可把商品名称添加缩写，发送短信商品按缩写发，无设置则按全称发。"
                  placement="bottom-start"
                >
                  <img src="../../../assets/images/ask.png" alt style="vertical-align:middle;">
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <div style="width:200px;margin:0 auto;">
                  <el-input
                    maxlength="10"
                    style="width:300px;"
                    placeholder="请输入缩写"
                    v-model="scope.row.shortWords"
                  >
                    <el-button @click="setShortWords(scope.row,scope.$index)" slot="append">确认</el-button>
                  </el-input>
                </div>
                <!-- <div v-else>
                  <el-button
                    @click="updateShort(scope.row.state,scope.$index)"
                    type="text"
                  >{{scope.row.titleShort?'修改缩写':'编辑缩写'}}</el-button>
                </div>-->
              </template>
            </el-table-column>
          </el-table>
          <pagination
            @transferName="leftCurrentChange"
            :total="leftPaginationInfo.total"
            style="width: 566px;float:right"
          ></pagination>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDialogConfirm()" class="button" size="small">确定</el-button>
        <el-button @click="handleDialogClose()" class="button" size="small">取消</el-button>
      </div>-->
    </el-dialog>
  </div>
</template>

<script>
import {
  getBrandList,
  getTaobaocats,
  getSellercats,
  getTaobaoItemList,
  updateTaobaoItemTitle
} from "@/api/public";
import Pagination from "@/components/pagination";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "select-goods",
  components: { Pagination },
  props: {
    postForm: {
      type: Array
    }
  },
  data() {
    return {
      changeColor: "#2062E7",
      selectDialog: true,
      brandVisible: false, //指定品牌弹出框
      brandOptions: "", //品牌列表
      checkedBrands: [], //选中品牌
      checkedBrandsString: "", //选中的品牌ID
      isIndeterminate: true,
      checkAll: false,
      checkedAll: false,
      /*
       * 类目选择相关
       * */
      classifyOptions: [
        {
          value: 1,
          label: "淘宝类目"
        },
        {
          value: 2,
          label: "店铺类目"
        }
      ],
      classifyValue: 1,
      classifyIndex: 1,
      classifyIdArray: [],
      classifyIdString: "",
      visible: false, //类目渲染
      /*
       * 商品状态相关
       * */
      goodState: [
        {
          value: 0,
          label: "全部商品"
        },
        {
          value: 1,
          label: "在售"
        },
        {
          value: 2,
          label: "待售"
        }
      ],
      goodValue: 0,
      /*
       * 树形选择相关
       * */
      cats: [], //当前展示的类目
      taobaoCats: [], //淘宝类目
      sellerCats: [], //店铺类目
      props: {
        label: "speName001",
        children: "child"
      },
      itemTitle: "", //商品名称
      numIid: "", //商品id
      startPrice: "", //开始价格
      endPrice: "", //结束价格
      /*
       * 选择商品左侧表格
       * */
      babyList: [],
      leftData: [],
      newData: [],
      alreadyList: [],
      /*
       * 左侧商品分页数据
       * */
      leftPaginationInfo: {
        current: 1, //当前页数
        pageSize: 10, //当前页面数据大小
        total: 0 //数据总数
      },
      /*
       * 选择商品右侧表格
       * */
      rightData: [],
      /*
       * 右侧商品分页数据
       * */
      rightPaginationInfo: {
        tableCurrentPage: 1,
        pageSize: 5,
        totalCount: 0
      }
    };
  },
  computed: {
    ...mapState(["modelName"])
  },
  beforeCreate() {},
  beforeMount() {},
  created() {
    let self = this;
    let alreadyList = [];
    if (this.postForm && this.postForm.length > 0) {
      alreadyList = this.postForm.map(item => {
        return {
          ...item
        };
      });
    }
    for (let i = 0; i < alreadyList.length; i++) {
      alreadyList[i].state = true;
    }
    for (const item of alreadyList) {
      this.leftData.push(item);
      this.rightData.push(item);
    }
    this.rightPaginationInfo.totalCount = this.rightData.length;
  },
  mounted() {
    let self = this;
    // console.log(this.modelName);
    /*
     * 获取品牌列表
     * */
    getBrandList({}).then(res => {
      // console.log("%c 品牌列表", "color: green", res.data);
      self.brandOptions = res.data;
    });
    /*
     * 获取淘宝类目
     * */
    getTaobaocats({}).then(res => {
      // console.log("%c 淘宝类目", "color: green", res.data);
      self.cats = res.data;
      self.taobaoCats = res.data;
    });
    /*
     * 获取店铺类目
     * */
    getSellercats({}).then(res => {
      // console.log("%c 店铺类目", "color: green", res.data);
      self.sellerCats = res.data;
    });
    /*
     * 获取商品列表
     * */
    self.getTaobaoItemList();
  },
  methods: {
    validNum(val){console.log(val);
      this.numIid=val.replace(/[^0-9,]+/g,'');
    },
    changeNum(val){
      let that=this,testArr=[];
      this.numIid.split(",").forEach((val)=>{
        if(val!='' && /^[0-9]+$/.test(val)){
            testArr.push(val);
         }
      });
      this.numIid=testArr.join(',');
    },
    //编辑修改缩写点击
    updateShort(item, i) {
      this.leftData[i].state = !this.leftData[i].state;
    },
    //发起请求修改编辑 缩写
    setShortWords(item, i) {
      // console.log(item, i);
      let params = {
        taobaoItemId: item.taobaoItemId,
        titleShort: item.shortWords
      };
      updateTaobaoItemTitle(params)
        .then(res => {
          if (res.code == 200) {
            this.$message.success(res.message);
            this.leftData[i].titleShort = this.leftData[i].shortWords;
            this.leftData[i].shortWords = "";
            // this.leftData[i].state = !this.leftData[i].state;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(e => {
          // console.log(e);
        });
    },
    /*
     * 商品类目全选按钮监听事件
     * */
    handleCheckAllChangeTaoBao(val) {
      if (val) {
        if (this.classifyIndex === 1) {
          this.$refs.taobaoTree.setCheckedNodes(this.taobaoCats);
        } else {
          this.$refs.sellerTree.setCheckedNodes(this.sellerCats);
        }
      } else {
        if (this.classifyIndex === 1) {
          this.$refs.taobaoTree.setCheckedNodes([]);
        } else {
          this.$refs.sellerTree.setCheckedNodes([]);
        }
      }
    },
    handleCheckAllChange(val) {
      // console.log("%c 品牌全选事件", "color: green", val);
      this.checkedBrands = val ? this.brandOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedBrandsChange(value) {
      // console.log("%c 品牌单选事件", "color: green", value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.brandOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.brandOptions.length;
    },
    /* 品牌弹窗确认按钮 */
    brandConfirm() {
      const that = this;
      let checkedBrands = that.checkedBrands;
      let checkedBrandsArray = [];
      checkedBrands.forEach(function(value) {
        checkedBrandsArray.push(value.pid);
      });
      // console.log("%c 选中的品牌Id", "color: green", checkedBrandsArray);
      that.checkedBrandsString = checkedBrandsArray.join(",");
      that.brandVisible = false;
    },
    /*
     * 监听类目的变化
     * */
    classifyChange(value) {
      this.classifyIndex = value;
      this.checkedAll = false;
      this.classifyIdArray = [];
      this.classifyIdString = "";
    },
    /*
     * 树形控件相关
     * */
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate);
      // 判断全选状态，根据索引来
      if (this.classifyIndex === 1) {
        // console.log('淘宝');
        let arr = this.$refs.taobaoTree.getCheckedKeys();
        // console.log(arr)
        // console.log(this.taobaoCats)
      } else {
        // console.log('店铺');
        let arr = this.$refs.sellerTree.getCheckedKeys();
        // console.log(arr)
        // console.log(this.sellerCats)
      }
    },
    /*
     * 确认类目事件
     * */
    getCheckedKeys() {
      const that = this;
      let classifyIndex = that.classifyIndex;
      let classifyIdArray = [];
      if (classifyIndex == 1) {
        // console.log(that.$refs.taobaoTree.getCheckedKeys());
        classifyIdArray = that.$refs.taobaoTree.getCheckedKeys();
        that.classifyIdArray = classifyIdArray;
        that.classifyIdString = classifyIdArray.join(",");
      } else if (classifyIndex == 2) {
        // 获取所有选中的id
        // console.log(that.$refs.sellerTree.getCheckedKeys());
        classifyIdArray = that.$refs.sellerTree.getCheckedKeys();
        that.classifyIdArray = classifyIdArray;
        that.classifyIdString = classifyIdArray.join(",");
      }
      that.visible = false;
    },
    /*
     * 弹窗确认事件
     * */
    handleDialogConfirm() {
      const that = this;
      let rightData = that.rightData;
      // let numIids = [];
      // console.log(that.modelName.type)
      rightData.forEach(function(value) {
        value.type = that.modelName.type;
      });
      // console.log(numIids);
      // console.log(rightData);
      // console.log(that.leftData)
      this.$emit("transferName", rightData);
      this.selectDialog = true;
    },
    /*
     * 弹窗关闭事件
     * */
    handleDialogClose() {
      // const that = this;
      // let rightData = that.rightData;
      // rightData.forEach(function(value) {
      //   value.type = that.modelName.type;
      // });

      this.$emit("closeBaby", false);
      // this.selectDialog = true;
    },
    /*
     * 获取淘宝商品列表
     * */
    getTaobaoItemList() {
      /**
       * approveStatus (string, optional): 商品状态 不填查全部，在售 1，待售 2 ,//
        categoryType (string, optional): 商品类目类型 0店铺类目 1淘宝类目 ,//
        cid (string, optional): 商品类目ID 勾选父级 传入相应子集 英文逗号拼接 1,2,3 ,//
        endPrice (string, optional): 商品价格区间 ,//
        itemTitle (string, optional): 商品名称 ,//
        numIid (string, optional): 商品id ,itemTitle -//
        pageNum (integer, optional): 当前页 ,//
        pageSize (integer, optional): 每页大小 ,//
        pid (string, optional): 商品品牌ID 英文逗号拼接 1,2,3 ,//
        startPrice (string, optional): 商品价格区间//
       */
      const self = this;
      let checkedBrandsString = self.checkedBrandsString, //指定品牌ID数组
        classifyIndex = self.classifyIndex, //商品类目类型
        classifyIdString = self.classifyIdString, //宝贝类目id数组
        itemTitle = self.itemTitle, //商品名称(请输入商品名称、商品编码、商品id、关键词)
        goodValue = self.goodValue, //商品状态
        startPrice = self.startPrice, //开始价格
        endPrice = self.endPrice; //结束价格
      // 判断商品类目 0店铺类目 1淘宝类目
      if (classifyIndex === 2) {
        // 店铺
        classifyIndex = 0;
      }
      // 判断商品状态 不填''查全部，在售 1，待售 2
      if (self.goodValue === 0) {
        goodValue = "";
      }
      var formData = {
        approveStatus: goodValue,
        categoryType: classifyIndex,
        cid: classifyIdString,
        endPrice: endPrice,
        itemTitle: itemTitle, //商品名称
        numIid: self.numIid, //商品id
        pageNum: self.leftPaginationInfo.current,
        pageSize: self.leftPaginationInfo.pageSize,
        pid: checkedBrandsString,
        startPrice: startPrice
      };
      getTaobaoItemList(formData).then(res => {
        if (res.code === 200) {
          let dataList = res.data.dataList;
          //给商品列表添加一个state属性判断是否可以被选中
          for (let i = 0; i < dataList.length; i++) {
            dataList[i].state = false;
            dataList[i].shortWords = "";
          }
          self.newData = dataList;
          self.leftData = dataList;
          //根据右边判断
          if (self.rightData.length === 0) {
            // 首次加载
            // console.log("首次加载");
            // self.leftData = dataList
          } else {
            // console.log("已有数据");
            // console.log(self.leftData);
            //获取的数据与原数据对比(numIid),无则追加，有则跳过
            let nowList = self.newData; //当前新获取的数据
            let newList = []; //不存在旧数据的临时数据
            for (const newItem of nowList) {
              let i = 0;
              for (const oldItem of self.rightData) {
                i++;
                if (newItem.numIid != oldItem.numIid) {
                  if (i === self.rightData.length) {
                    // 内层循环完新添加进新数组
                    newList.push(newItem);
                  }
                  continue;
                } else {
                  break;
                }
              }
            }
            // 追加新加的元素 (右边和最新数据对比过滤)
            // console.log(newList);
            if (newList.length === 0) {
              for (const item of self.leftData) {
                item.state = true;
              }
            } else {
              for (const item1 of self.leftData) {
                let i = 0;
                for (const item of newList) {
                  i++;
                  if (item1.numIid != item.numIid) {
                    if (i === newList.length) {
                      // 内层循环完新添加进新数组
                      item1.state = true;
                    }
                    continue;
                  } else {
                    break;
                  }
                }
              }
            }
          }
          self.leftPaginationInfo.total = res.data.pageInfo.total;
        }
      });
    },
    // getTaobaoItemList() {
    //   /**
    //    * approveStatus (string, optional): 商品状态 不填查全部，在售 1，待售 2 ,//
    //     categoryType (string, optional): 商品类目类型 0店铺类目 1淘宝类目 ,//
    //     cid (string, optional): 商品类目ID 勾选父级 传入相应子集 英文逗号拼接 1,2,3 ,//
    //     endPrice (string, optional): 商品价格区间 ,//
    //     itemTitle (string, optional): 商品名称 ,//
    //     numIid (string, optional): 商品id ,itemTitle -//
    //     pageNum (integer, optional): 当前页 ,//
    //     pageSize (integer, optional): 每页大小 ,//
    //     pid (string, optional): 商品品牌ID 英文逗号拼接 1,2,3 ,//
    //     startPrice (string, optional): 商品价格区间//
    //    */
    //   const self = this;
    //   let checkedBrandsString = self.checkedBrandsString, //指定品牌ID数组
    //     classifyIndex = self.classifyIndex, //商品类目类型
    //     classifyIdString = self.classifyIdString, //宝贝类目id数组
    //     itemTitle = self.itemTitle, //商品名称(请输入商品名称、商品编码、商品id、关键词)
    //     goodValue = self.goodValue, //商品状态
    //     startPrice = self.startPrice, //开始价格
    //     endPrice = self.endPrice; //结束价格
    //     // 判断商品类目 0店铺类目 1淘宝类目
    //   if (classifyIndex === 2) {
    //     // 店铺
    //     classifyIndex = 0
    //   }
    //   // 判断商品状态 不填''查全部，在售 1，待售 2
    //   if (self.goodValue === 0) {
    //     goodValue = ''
    //   }
    //   var formData = {
    //     approveStatus: goodValue,
    //     categoryType: classifyIndex,
    //     cid: classifyIdString,
    //     endPrice: endPrice,
    //     itemTitle: itemTitle,//商品名称
    //     numIid: self.numIid,//商品id
    //     pageNum: self.leftPaginationInfo.current,
    //     pageSize: self.leftPaginationInfo.pageSize,
    //     pid: checkedBrandsString,
    //     startPrice: startPrice
    //   }
    //   console.log(formData)
    //   getTaobaoItemList(formData).then(res => {
    //     if (res.code === 200) {
    //       let dataList = res.data.dataList;
    //       //给商品列表添加一个state属性判断是否可以被选中
    //       for (let i = 0; i < dataList.length; i++) {
    //         dataList[i].state = false;
    //       }
    //       self.newData = dataList
    //       if(self.leftData.length === 0) {
    //         // 首次加载
    //         console.log('首次加载')
    //         for (const item of dataList) {
    //           self.leftData.push(item)
    //         }
    //       } else {
    //         console.log('已有数据')
    //         console.log(self.leftData)
    //         //获取的数据与原数据对比(numIid),无则追加，有则跳过
    //         let nowList = self.newData;//当前新获取的数据
    //         let newList =  [];//不存在旧数据的临时数据
    //         for (const newItem of nowList) {
    //           let i = 0
    //           for (const oldItem of self.leftData) {
    //             i++
    //             if(newItem.numIid != oldItem.numIid) {
    //               if (i === self.leftData.length) {
    //                 // 内层循环完新添加进新数组
    //                 newList.push(newItem)
    //               }
    //               continue
    //             }
    //             else {
    //               break
    //             }
    //           }
    //         }
    //         // 追加新加的元素
    //         console.log(newList)
    //         for (const item of newList) {
    //           self.leftData.push(item)
    //         }
    //       }
    //       self.leftPaginationInfo.total = res.data.pageInfo.total;
    //     }
    //   })
    // },
    /*
     * 左侧商品分页事件
     * */
    leftCurrentChange(event) {
      this.leftPaginationInfo.current = event.current;
      this.leftPaginationInfo.pageSize = event.pageSize;
      this.getTaobaoItemList();
    },
    /*
     * 左侧表格单选按钮
     * */
    handleSelect(row, index) {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;
      if (row.state === false) {
        rightData.push(row);
        leftData[index].state = true;
      }
      that.leftData = leftData;
      that.rightPaginationInfo.totalCount = rightData.length;
    },
    /*
     * 左侧表格全选按钮
     * */
    handleAllSelect() {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;

      for (let i = 0; i < leftData.length; i++) {
        if (leftData[i].state === false) {
          rightData.push(leftData[i]);
          leftData[i].state = true;
        }
      }
      that.leftData = leftData;
      that.rightData = rightData;

      that.rightPaginationInfo.totalCount = rightData.length;
    },
    /*
     * 左侧表格状态颜色
     * */
    tableRowClassName({ row }) {
      if (row.state === true) {
        return "success-row";
      }
      return "";
    },
    /*
     * 右侧表格删除按钮
     * */
    handleDelete(row, index) {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;
      rightData.splice(index, 1);
      for (let i = 0; i < leftData.length; i++) {
        if (leftData[i].numIid == row.numIid) {
          that.leftData[i].state = false;
        }
      }
      that.rightPaginationInfo.totalCount = rightData.length;
      that.rightData = rightData;
    },
    /*
     * 右侧表格清空按钮
     * */
    handleClear() {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;

      for (let i = 0; i < rightData.length; i++) {
        for (let j = 0; j < leftData.length; j++) {
          if (rightData[i].numIid == leftData[j].numIid) {
            leftData[j].state = false;
          }
        }
      }
      that.leftData = leftData;

      rightData.splice(0, rightData.length);
      that.rightPaginationInfo.totalCount = 0;
    },
    /*
     * 右侧分页事件
     * */
    // rightCurrentChange(val) {
    //   this.rightPaginationInfo.tableCurrentPage = val;
    // },
    /*
     * 查询按钮
     * */
    searchList() {
      // 执行查询接口
      this.getTaobaoItemList();
    }
  }
};

</script>

<style lang="scss" scoped>
.evaluate-dialog-wrapper {
  .screen-box {
    .line {
      font-size: 14px;
      color: #666666;
      margin-bottom: 10px;
      .item {
        display: inline-block;
        vertical-align: middle;
        margin-right: 60px;
        .input {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
        }
        .brandButton {
          width: 200px;
        }
        .classify-select {
          display: inline-block;
          vertical-align: middle;
          width: 145px;
          margin-right: 13px;
        }
        .goods-button {
          display: inline-block;
          vertical-align: middle;
          width: 123px;
        }
        .long-input {
          width: 270px;
        }
        .goods-select {
          width: 200px;
        }
        .short-input {
          width: 85px;
          display: inline-block;
          vertical-align: middle;
        }
        .text {
          display: inline-block;
          margin: 0 10px;
        }
      }
    }
  }
  .table-box {
    overflow: hidden;
    margin-top: 12px;
    .shops-goods {
      position: relative;
      .goods-left {
        float: left;
        width: 100px;
        .goods-img {
          width: 80px;
          float: left;
          margin: 20px 10px 10px 10px;
        }
      }
      .goods-right {
        // margin: 10px;
        font-size: 16px;
        height: 100px;
        float: right;
        text-align: left;
        width: 300px;
      }
    }

    overflow: hidden;

    .goods-content {
      float: left;
      width: 340px;
      .goods-title {
        display: block;
        text-align: left;
        margin-bottom: 6px;
      }
      .goods-detail {
        display: block;
        overflow: hidden;
        .goods-id {
          display: block;
          float: left;
          font-size: 14px;
        }
        .goods-price {
          display: block;
          float: right;
          .price {
            font-size: 20px;
          }
        }
      }
    }
    .add-button {
      font-size: 24px;
      cursor: pointer;
    }
    .addDisabled {
      cursor: not-allowed;
    }

    .table-right {
      float: right;
      overflow: hidden;
      .is-select {
        color: #ff7600;
      }
      .goods-img {
        width: 80px;
        float: left;
        margin-right: 10px;
      }
      .goods-content {
        float: left;
        width: 340px;
        .goods-title {
          display: block;
          text-align: left;
          margin-bottom: 6px;
        }
        .goods-detail {
          display: block;
          overflow: hidden;
          .goods-id {
            display: block;
            float: left;
            font-size: 12px;
          }
          .goods-price {
            display: block;
            float: right;
            .price {
              font-size: 20px;
            }
          }
        }
      }
      .delete-button {
        font-size: 24px;
        cursor: pointer;
      }
    }
  }
}
/* 滚动条样式修改 */
.popper-wrapper,
.el-checkbox-group {
  /* background-color: #666; */
  max-height: 250px !important;
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-checkbox-group::-webkit-scrollbar,
.popper-wrapper::-webkit-scrollbar {
  width: 0px;
  background-color: #fff;
  border-radius: 10px;
  padding: 5px 0;
}
.el-checkbox-group:hover::-webkit-scrollbar,
.popper-wrapper:hover::-webkit-scrollbar {
  width: 6px;
}
.el-checkbox-group::-webkit-scrollbar,
.popper-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #d6d8dd;
  overflow: hidden;
}
</style>

<style lang="scss">
.el-popper {
  padding: 10px !important;
  max-height: 600px;
  overflow-y: auto;
}

.el-table .success-row {
  background: #f5f7fa;
  cursor: not-allowed;
  opacity: 0.4;
}
.addDisabled {
  cursor: not-allowed;
}
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
</style>
